// We create Redux store directly, instead of using any extra dependencies.
import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import appReducer from './reducers';
import * as analytics from './analytics/analytics';
import appSettings from './config/settings';
import { logout } from './ducks/auth.duck';
import { createAuthBridgeMiddleware } from './v2/stores/auth/bridge';

/**
 * Create a new store with the given initial state. Adds Redux
 * middleware and enhancers.
 */
export default function configureStore(initialState = {}, sdk = null, analyticsHandlers = []) {
  const middlewares = [
    thunk.withExtraArgument(sdk),
    analytics.createMiddleware(analyticsHandlers),
    // Bridges legacy Redux user/auth state into the v2 Zustand auth store
    // (src/v2/stores/auth) — keeps v2 code from ever importing Redux directly.
    createAuthBridgeMiddleware(logout),
  ];

  // Enable Redux Devtools in client side dev mode.
  const composeEnhancers =
    appSettings.dev && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;

  const enhancer = composeEnhancers(applyMiddleware(...middlewares));
  const store = createStore(appReducer, initialState, enhancer);
  return store;
}
